export const cardsReducer = (state = {loading:true,result:null,cards:null,card:null} , action) => {
    switch (action.type) {
        case 'CARD_SEND_SUCCESS':
            return {
                ...state,
                loading:false,
                result: action.payload
            }
        case 'CARDS_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                cards: action.payload
            }
        case 'CARD_GET_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                card: action.payload
            }
        case 'CARD_GET_BY_OPERATOR_SUCCESS':
            return {
                ...state,
                loading:false,
                card: action.payload
            }
        case 'CARD_GET_BY_DATE_SUCCESS':
            return {
                ...state,
                loading:false,
                cards: action.payload
            }
        case 'CARD_GET_BY_MONTH_SUCCESS':
            return {
                ...state,
                loading:false,
                cards: action.payload
            }
        case 'CARD_GET_BY_DATE_BY_OPERATOR_SUCCESS':
            return {
                ...state,
                loading:false,
                cards: action.payload
            }
        case 'CARD_DELETE_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                cards: state.cards.filter(card => card._id !== action.payload.idCard)
            }
        case 'CARD_DELETE_NOT_SUCCESS':
            return {...state,
                loading: false,
                result: action.payload
            }
        case 'CARD_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'CARD_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'CARD_ERROR':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

